<template>
  <!-- 导入 -->
  <Drawer
    title="自定义对象导入"
    v-model="orgImModal"
    width="600"
    :mask-closable="true"
    @on-close="orgImModalCancel"
    class="import-model"
  >
    <Form
      :label-width="80"
      :rules="importRuleValidate"
      ref="importFormData"
      :model="importFormData"
    >
      <input
        type="file"
        ref="File"
        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        v-show="0"
        @change="handleFileChange"
      />
      <p class="import-tip import-tip-top">
        <Icon type="md-alert" size="14" color="#FBAC06" />导入数据过程中请勿修改表格表头，否则可能造成导入失败！
      </p>
      <h2 class="import-title">第一步：请选择一个业务类型</h2>
      <FormItem prop="businessType" class="import-busType">
        <Select
          v-model="importFormData.businessType"
          placeholder="请选择业务类型"
          @on-change="changebusType"
        >
          <Option v-for="item in businesses" v-if = "item.isFlowType == 0" :value="item.sbtId" :key="item.sbtId">
            {{
            item.sbtName }}
          </Option>
        </Select>
        <p class="import-tip-down" :class="busSelectDisabled ? '' : 'import-tip-gray'">
          <a :href="importTemplateUrl">下载导入摸板</a>
        </p>
      </FormItem>
      <h2 class="import-title" :class="busSelectDisabled ? '' : 'import-title-gray'">第二步：查重覆盖模式</h2>
      <p
        class="import-tip"
        :class="busSelectDisabled ? '' : 'import-title-gray'"
      >我们将按照选择的字段进行查询，针对重复的数据进行操作：</p>
      <FormItem class="import-busType" style = "padding-bottom:10px;">
        <Select
          not-found-text = '无可选唯一性的字段'
          placeholder= '请选择查重字段'
          v-model="importFormData.mofId"
          :disabled="!busSelectDisabled"
        >
          <Option
            v-for="opt in uniqueFields"
            :value="opt.mofId"
            :key="opt.mofId"
          >{{opt.fieldName}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="operType" v-if = "uniqueFields.length">
        <RadioGroup v-model="importFormData.operType">
          <Radio
            :label="item.key"
            :key="item.key"
            v-for="item in operTypeList"
            :disabled="!busSelectDisabled"
          >
            <span>{{item.value}}</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <h2 v-show="showThree" class="import-title">第三步：设置特殊字符</h2>
      <p
        v-show="showThree"
        class="import-tip"
        style="margin-bottom:16px;" 
      >针对无法通过导入导入的字段，可以通过统一预设的值进行设置 </p>
      <Spin fix v-if="loading"></Spin>
      <div v-if="showThree">
        <template v-for="(item,index) in imoprtCustomData.columnsList">
          <FormItem
            :key="index"
            :prop="item.fieldValue"
            :rules="rulesParams(item, index)"
            class="import-busType1"
          >
            <span slot="label" v-if="item.isShowData">
              <Tooltip
                placement="top"
                transfer
                :content="item.fieldName"
                :disabled="!item.fieldName.length > 4"
              >{{item.fieldName.length > 4 ? item.fieldName.substring(0, 4) + '...' : item.fieldName}}</Tooltip>
            </span>
            <template v-if="item.fieldType == fieldTypePhoto">
              <div
                :key = "index"
                v-model="item.fieldValue"
                class="custom-upload-list"
                v-if="photoList['photoSuccess_' + item.mofId]"
                v-for="(photo,index) in photoList['photo_' + item.mofId]"
              >
                <template v-if="photo.status == 'finished'">
                  <img :src="imgUrl + photo.response.bean.attachmentId" />
                  <div class="custom-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(photo)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemovePhoto(item, photo)"></Icon>
                  </div>
                </template>
              </div>
              <Upload
                :ref="'upload_'+item.mofId"
                :show-upload-list="false"
                :format="['jpg', 'jpeg', 'png']"
                :max-size="5120"
                multiple
                :on-exceeded-size="handleErrorSize"
                :on-format-error="handleError"
                style="display:inline-block"
                :action="customFileUrl"
                :data="{ data: item }"
                :before-upload="(value, file, fileList) => handleBeforeUpload(item, value, file, fileList)"
                :on-success="(value, file, fileList) => handlePhotoSuccess(item, value, file, fileList)"
              >
                <div
                  v-show="photoList['photo_' + item.mofId] && photoList['photo_' + item.mofId].length < item.picUploadNum"
                  class="camera"
                  style="width: 58px;height:58px;line-height: 58px;"
                >
                  <CIcon icon="ziduanleixing-tupian" size="40" />
                </div>
              </Upload>
              <Modal title="照片" v-model="visible" footer-hide>
                <img :src="imgPreview" v-if="visible" style="width: 100%" />
              </Modal>
            </template>
            <Select
              transfer="true"
              v-if="item.fieldType == fieldTypeObject && isParent"
              filterable
              :placeholder="'请选择' + item.fieldName"
              v-model="item.fieldValue"
              @on-change = "selChange"
            >
              <Option
                v-for="opt in item.dicOptions"
                @click.native="getObjectSelectData(item, opt)"
                :value="opt.label"
                :key="opt.value"
                :label="String(opt.value)"
                v-if="opt.show"
              >{{opt.value}}</Option>
            </Select>
            <Select
              transfer="true"
              v-if="item.fieldType == fieldTypeMainChild && isParent"
              filterable
              :placeholder="'请选择' + item.fieldName"
              v-model="item.fieldValue"
              @on-change = "selChange"
            >
              <Option
                v-for="opt in item.dicOptions"
                @click.native="getObjectSelectData(item, opt)"
                :value="opt.label"
                :key="opt.value"
                :label="String(opt.value)"
                v-if="opt.show"
              >{{opt.value}}</Option>
            </Select>
          </FormItem>
        </template>
      </div>
      <h2
        v-show="showThree"
        class="import-title"
        :class="busSelectDisabled ? '' : 'import-title-gray'"
      >第四步：上传填写好的模版</h2>
      <h2
        v-show="!showThree"
        class="import-title"
        :class="busSelectDisabled ? '' : 'import-title-gray'"
      >第三步：上传填写好的模版</h2>
      <div class="btn-upload">
        <Button
          type="dashed"
          size="large"
          icon="ios-cloud-upload-outline"
          @click="handleSelectFile"
          :disabled="!busSelectDisabled"
        >{{excelFile ? '重新上传' : '上传文件'}}</Button>
      </div>

      <p class="error-tip" v-if="!uploadFileErrorState">{{uploadFileTip}}</p>

      <p :class="busSelectDisabled ? '' : 'import-title-gray'">1.只支持.xls 和.xlsx 格式</p>
      <p :class="busSelectDisabled ? '' : 'import-title-gray'">2.上传成功后不可修改第一步的业务类型</p>

      <div class="fileinfo" v-if="excelFile">
        <span class="filename" :title="fileName">{{fileName}}</span>
        <a class="btn-delete" title="删除" @click="handleDelete">
          <Icon type="ios-close" />
        </a>
      </div>

      <div class="success-tip" v-if="!uploadFileSuccessState">
        <p>
          <Icon type="md-alert" size="14" color="#00B8C4" />
          {{uploadFileTip}}
        </p>
        <p class="import-tip-down">
          <a :href="uploadTemplateUrl">下载上传结果</a>
        </p>
      </div>
    </Form>
    <div class="import-footer">
      <Button class="btn-cancel" @click="orgImModalCancel">取消</Button>
      <Button type="primary" :disabled="sbtnDisabled" @click="importSubmit()">开始导入</Button>
    </div>
  </Drawer>
</template>
<script>
import envConst from '@/env-const.js'
import { mConst } from './mConst.js'

const dynicMaxAndMinLength = (rule, value, callback) => {
    if(value != null&&value != ''){
        if (value.trim().gllength()> rule.maxLength) {
            callback(new Error("请输入"+rule.minLength+"-"+ rule.maxLength+"个字符(1汉字=2字母=2字符)"));
        }
        if (value.trim().gllength()< rule.minLength) {
            callback(new Error("请至少输入"+ rule.minLength+"个字符(1汉字=2字母=2字符)"));
        }
    }
    callback()
};

export default {
  props: {
    businesses: Array,
    objectId: String,
    viewId: String
  },
  data() {
    return {
      uniqueFields: [],//查重字段
      orgImModal: false,
      importFormData: {
        busType: '',
        operType: '0',
        businessType: null,
        mofId: ''
      },
      importRuleValidate: {},
      imbusType: '',
      busSelectDisabled: false,
      operTypeList: [
        {
          key: '0',
          value: '重复数据不导入'
        },
        {
          key: '1',
          value: '覆盖原有的数据'
        }
      ],
      exportFieldList: [],
      exportColumsList: [],
      indeterminate1: false,
      checkAllColmus: false,
      exportFormData: {
        exportColums: []
      },
      excelFile: '',
      importTemplateUrl: 'javascript:void(0)',
      uploadTemplateUrl: 'javascript:void(0)',
      sbtnDisabled: true,
      resourceData: {
        moId: ''
      },
      OBJECT_NAME: '',
      importBusinesses: [],
      imoprtCustomData: {
        columnsList: []
      },
      dymaticKeyList: [],
      version: mConst.custom.version,
      selectType: mConst.custom.type.selectType,
      showThree: false,
      loading: false,
      fieldTypePhoto: mConst.fieldTypePhoto, //图片类型
      fieldTypeObject: mConst.fieldTypeObject, //对象
      fieldTypeObjectParam: mConst.fieldTypeObjectParam, //引用字段
      fieldTypeMainChild: mConst.fieldTypeMainChild, //主子明细
      handleUuId: '',
      customFileUrl: '',
      photoList: {},
      visible: false,
      imgUrl: '/file/filemanage/downloadFileById/',
      imgPreview: '',
      isParent: true,
      currentData: [],
      itsPropertiesMain: mConst.itsPropertiesMain,
      itsPropertiesObject: mConst.itsPropertiesObject,
      itsPropertiesSystem: mConst.itsPropertiesSystem,
      uploadFileErrorState: true,
      uploadFileTip: '',
      uploadFileSuccessState: true,
      excelData: '',
      fileName: '',
      filePath: ''
    }
  },
  created(){
    // this.getDubCheckFields()
  },
  methods: {
    selChange(e){
      console.log(e)
    },
    getDubCheckFields(objectId){//获取查重字段
      objectId = objectId || this.objectId
      this.$http.get(`/scmd/import/excel/getUniqueField?moId=${objectId}&sbtId=${this.importFormData.businessType}`).then(({data}) => {
        if(data.returnCode == "0"){
          this.uniqueFields = data.beans
        }else{
          this.$Message.error(data.returnMessage)
        }
      })
    },
    open(e) {
      console.log(e)
      this.orgImModal = true
    },
    // 导出 导入
    importClientData() {
      this.orgImModal = true
    },
    changebusType() {
      console.log(this.importFormData.businessType)
      if (!this.importFormData.businessType) {
        this.busSelectDisabled = false
      } else {
        this.busSelectDisabled = true
        this.loading = true
        this.showThree = false
        this.photoList = {}
        let tempObj = {}
        for (let item in this.importFormData) {
          if (item.indexOf('columnsList') == -1) {
            this.$set(tempObj, item, this.importFormData[item])
          }
        }
        this.importFormData = tempObj
        this.$nextTick(this.$refs['importFormData'].validate)
        this.importRuleValidate = {}
        this.imoprtCustomData = { columnsList: [] }
        this.dymaticKeyList = []
        this.importBusinesses = []
        setTimeout(() => {
          this.initMethod()
          this.loading = false
        })
      }
      this.getDubCheckFields()
      this.downTemplate()
    },
    downTemplate() {
      if (!this.importFormData.businessType) {
        return
      } else {
        let moId = this.objectId
        let businessType = this.importFormData.businessType
        this.importTemplateUrl =
          '/scmd/import/excel/template?moId=' +
          moId +
          '&businessType=' +
          businessType
      }
    },
    searchExportColumns(viewId) {
      // console.log(viewId)
      this.$http
        .get(
            '/scmd/fields/getFieldAndDataListByViewId?viewId=' +
            viewId
        )
        .then(response => {
          if (response.data.returnCode === 0) {
            let fieldList = response.data.bean.fieldList
            // console.log(fieldList);
            if (!response.data.bean.mtIdShow) {
              let fieldCname = 'mt_id'
              fieldList = fieldList.filter(obj => {
                return fieldCname !== obj.fieldCname
              })
            }
            if (!response.data.bean.businessTypeShow) {
              let fieldCname = 'business_type'
              fieldList = fieldList.filter(obj => {
                return fieldCname !== obj.fieldCname
              })
            }
            this.exportFieldList = fieldList
            this.exportColumsList = fieldList.map(item => {
              // return {
              //     label: item.fieldName,
              //     value: item.fieldCname
              // }
              return item.fieldName
            })
            // console.log(this.exportColumsList);
          } else {
            this.$Message.error('查询失败!')
          }
        })
    },
    exportClientData() {
      this.orgExModal = true
    },
    orgImModalCancel() {
      this.uniqueFields = []
      this.importFormData.mofId = ""
      this.orgImModal = false
      this.busSelectDisabled = false
      this.$refs['importFormData'].resetFields()
      this.handleDelete()
      this.importTemplateUrl = 'javascript:void(0)'
      this.uploadTemplateUrl = 'javascript:void(0)'
      this.excelData = ''
      this.fileName = ''
      this.filePath = ''
      this.sbtnDisabled = true
      // 重置动态特殊字段相关变量
      this.showThree = false
      this.photoList = {}
      let tempObj = {}
      for (let item in this.importFormData) {
        if (item.indexOf('columnsList') == -1) {
          this.$set(tempObj, item, this.importFormData[item])
        }
      }
      this.importFormData = tempObj
      this.$nextTick(this.$refs['importFormData'].validate)
      this.importRuleValidate = {}
      this.imoprtCustomData = { columnsList: [] }
      this.dymaticKeyList = []
      this.importBusinesses = []
      this.uploadFileErrorState = true
      this.uploadFileSuccessState = true
      this.uploadFileTip = ''
    },
    importSubmit() {
      if (!this.importFormData.fileList) {
        this.$Message.error('请上传模板文件')
        return
      }
      // 表单验证
      let file = this.importFormData.fileList
      let operType = this.importFormData.operType
      let moId = this.objectId
      let businessType = this.importFormData.businessType
      let picField = {}
      let relateField = {}
      let quoteField = {}
      let mainChildField = {}
      // console.log(this.imoprtCustomData.columnsList);
      let imoprtColumnsList = this.imoprtCustomData.columnsList
      if (imoprtColumnsList.length > 0) {
        for (let i = 0; i < imoprtColumnsList.length; i++) {
          let item = imoprtColumnsList[i]
          if (item.fieldType == this.fieldTypePhoto) {
            if (
              this.photoList['photo_' + item.mofId].length < item.minimumUpload
            ) {
              this.$Message.error(
                '字段[' +
                  item.fieldName +
                  ']请上传至少' +
                  item.minimumUpload +
                  '张'
              )
              this.sbtnDisabled = false
              return
            } else {
              picField[item.fieldCname] = item.fieldValue
            }
          } else if (item.fieldType == this.fieldTypeObject) {
            relateField[item.fieldCname] = item.fieldValue
          }else if(item.fieldType == this.fieldTypeMainChild){
            mainChildField[item.fieldCname] = item.fieldValue
          }
          if(item.fieldType != this.fieldTypePhoto&&item.isRequired&&!item.fieldValue){
            this.$Message.error(
              '字段[' +
                item.fieldName +
                ']不能为空'
            )
            return
          }
          if(item.fieldType != this.fieldTypePhoto&&item.isRequired&&item.minLength&&item.fieldValue.length<item.minLength){
            this.$Message.error(
              '字段[' +
                item.fieldName +
                ']长度不能小于'+ item.minLength
            )
            return
          }
        }
      }
      for (let j = 0; j < this.dymaticKeyList.length; j++) {
        if (
          this.dymaticKeyList[j].fieldType == mConst.fieldTypeObjectParam &&
          this.dymaticKeyList[j].fieldValue !== 'undefined'
        ) {
          quoteField[this.dymaticKeyList[j].fieldCname] = this.dymaticKeyList[
            j
          ].fieldValue
        }
      }
      let params = {
        fileName: this.fileName,
        filePath: this.filePath,
        businessType,
        moId,
        operType,
        excelData: this.excelData,
        picField: JSON.stringify(picField),
        relateField: JSON.stringify(relateField),
        quoteField: JSON.stringify(quoteField),
        mainChildField: JSON.stringify(mainChildField)
      }
      if(this.importFormData.mofId){
        params.mofId = this.importFormData.mofId
      }
      this.sbtnDisabled = true
      // console.log(params);
      this.$http
        .post('/scmd/import/batch/import', params)
        .then(response => {
          if (response.data.returnCode === 0) {
            this.$Message.success('数据导入完成，正在处理，请稍后查询')
            // this.getTableData()
            this.$emit('hasImported')
            this.orgImModalCancel()
          } else {
            this.sbtnDisabled = false
            this.$Message.error('导入失败!')
          }
        })
    },
    // 文件改变处理
    handleFileChange({ target }) {
      let file = target.files[0]
      if (!file) return
      const isAllow = name => name.endsWith('.xls') || name.endsWith('.xlsx')
      if (file && !isAllow(file.name))
        return this.$Message.error('请选择Excel文件')
      if (file.size > 1024 * 1024 * 100)
        return this.$Message.error('请选择小于100M的文件.')
      target.value = ''
      const formData = new FormData()
      formData.append('file', file)
      formData.append('moId', this.objectId)
      formData.append('businessType', this.importFormData.businessType)
      if(this.importFormData.mofId){
        formData.append('mofId', this.importFormData.mofId)
      }
      // console.log(formData.get('file'));
      this.excelFile = file

      this.$http
        .post('/scmd/import/upload', formData)
        .then(response => {
          // console.log('上传成功');
          console.log(response.data)
          if (response.data.returnCode === 0) {
            // console.log(response.data.bean);
            this.importFormData.fileList = response.data.bean
            this.uploadFileErrorState = response.data.bean.checkState
              ? true
              : false
            this.uploadFileSuccessState = response.data.bean.checkState
              ? false
              : true
            this.uploadFileTip = response.data.bean.checkTwoMessage

            if (response.data.bean.checkState) {
              let fileKey = response.data.bean.fileKey
              let filePath = response.data.bean.filePath
              let fileName = response.data.bean.fileName
              this.excelData = JSON.stringify(response.data.bean.excelData)
              this.fileName = response.data.bean.fileName
              this.filePath = response.data.bean.filePath
              this.uploadTemplateUrl =
                '/scmd/import/excel/download?fileKey=' +
                fileKey +
                '&filePath=' +
                filePath +
                '&fileName=' +
                fileName
              this.sbtnDisabled = false
            } else {
              this.uploadTemplateUrl = 'javascript:void(0)'
              this.excelData = ''
              this.fileName = ''
              this.filePath = ''
              this.sbtnDisabled = true
            }
          } else {
            this.$Message.error(response.data.returnMessage)
            this.uploadFileErrorState = true
            this.uploadFileSuccessState = true
            this.uploadFileTip = ''
            this.uploadTemplateUrl = 'javascript:void(0)'
            this.excelData = ''
            this.fileName = ''
            this.filePath = ''
            this.sbtnDisabled = true
          }
        })
        .catch(error => {
          this.$Message.error('上传失败')
          this.uploadFileErrorState = true
          this.uploadFileSuccessState = true
          this.uploadFileTip = ''
          this.uploadTemplateUrl = 'javascript:void(0)'
          this.excelData = ''
          this.fileName = ''
          this.filePath = ''
          this.sbtnDisabled = true
        })
    },
    // 删除文件
    handleDelete() {
      this.excelFile = null
      this.importFormData.fileList = null
      this.sbtnDisabled = true
      this.uploadFileErrorState = true
      this.uploadFileSuccessState = true
      this.uploadFileTip = ''
      this.excelData = ''
      this.fileName = ''
      this.filePath = ''
    },
    // 选择文件
    handleSelectFile() {
      this.$refs.File.click()
    },
    // 生成随机数
    getUuid() {
      return (
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre() +
        this.uuIdPre()
      )
    },
    uuIdPre() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    initMethod() {
      this.searchTempViewByTableName(this.objectId)
      this.handleUuId = this.getUuid()
      this.customFileUrl =
        '/file/filemanage/uploadFile/' +
        this.handleUuId
    },
    searchTempViewByTableName(moId) {
      this.$http
        .get(
            '/scmd/Object/baseGetObject?moId=' +
            moId +
            '&objectState=' +
            mConst.custom.objectState
        )
        .then(response => {
          if (response.data.returnCode === 0) {
            if (response.data.beans.length > 0) {
              this.resourceData.moId = response.data.beans[0].moId
              this.OBJECT_NAME = response.data.beans[0].objectTname
              this.getBusinessTypeList(this.resourceData.moId)
              this.searchParamLists(this.resourceData.moId)
            } else {
            }
          } else {
          }
        })
    },
    // 查询导入业务类型列表
    getBusinessTypeList(moId) {
      this.$http
        .get(
            '/scmd/Object/getCustomObjectView?moId=' +
            this.resourceData.moId
        )
        .then(data => {
          if (data.data.bean.BusinessTypeList.length > 0) {
            this.importBusinesses = data.data.bean.BusinessTypeList
          } else {
            this.importBusinesses = []
          }
          // console.log('导入业务类型列表');
          // console.log(this.importBusinesses);
        })
    },
    searchParamLists(moId) {
      let that = this
      // this.$http.get(envConst.SCMD_API_BASE +'/scmd/layout/getLayout?moId=' +moId + '&busType=' +this.importFormData.businessType)
      this.$http
        .get(
            '/scmd/listlayout/getListLayoutFieldList?moId=' +
            moId +
            '&busType=' +
            this.importFormData.businessType
        )
        .then(res => {
          if (res.data.returnCode === 0) {
            // let fieldLists = res.data.bean.fieldLists; //得到要查询的列
            // this.imoprtCustomData.columnsList = res.data.bean.objectFieldLists ; //得到要查询的列
            // console.log(res.data.bean.objectFieldLists);
            // console.log(res.data.bean.objectFieldLists.length);
            // let temp = res.data.bean.objectFieldLists;
            let temp = res.data.beans
            let arr = []
            for (let i = 0; i < temp.length; i++) {
              if (
                temp[i].fieldType == this.fieldTypePhoto ||
                temp[i].fieldType == this.fieldTypeObject ||
                temp[i].fieldType == this.fieldTypeMainChild
              ) {
                arr.push(temp[i])
                this.$set(
                  this.importFormData,
                  'columnsList_' + i + '_fieldValue',
                  ''
                )
                that.$nextTick(this.$refs['importFormData'].validate)
                // this.$set(this.importRuleValidate,'columnsList.' + i + '.fieldValue',[{required:true}]);
              }
            }
            this.dymaticKeyList = temp
            console.log(arr)
            this.imoprtCustomData.columnsList = arr //得到要查询的列
            // 添加是否展示第三步
            this.showThree = arr.length > 0 ? true : false

            // console.log(this.imoprtCustomData.columnsList);
            // console.log(this.imoprtCustomData.columnsList.length);
            that.$nextTick(function() {
              for (
                let i = 0;
                i < this.imoprtCustomData.columnsList.length;
                i++
              ) {
                this.$set(
                  this.imoprtCustomData.columnsList[i],
                  'fieldValue',
                  ''
                )
                this.$set(
                  this.imoprtCustomData.columnsList[i],
                  'isDisabled',
                  false
                )
                this.$set(
                  this.imoprtCustomData.columnsList[i],
                  'isShowData',
                  true
                )
                this.$set(
                  this.imoprtCustomData.columnsList[i],
                  'isRelyField',
                  false
                )
              }
              // for(let item in this.imoprtCustomData.columnsList){
              //   let queryColumns = {
              //     title:this.imoprtCustomData.columnsList[item].fieldName,
              //     key:this.imoprtCustomData.columnsList[item].fieldCname,
              //     align:'center',
              //     tooltip:true
              //   }
              // }
              for (let item in this.imoprtCustomData.columnsList) {
                this.imoprtCustomData.columnsList[
                  this.imoprtCustomData.columnsList[item].fieldCname
                ] = ''
                //15.图片类型
                if (
                  this.imoprtCustomData.columnsList[item].fieldType ==
                  this.fieldTypePhoto
                ) {
                  if (
                    typeof this.$refs[
                      'upload_' + this.imoprtCustomData.columnsList[item].mofId
                    ] != 'undefined'
                  ) {
                    this.$refs[
                      'upload_' + this.imoprtCustomData.columnsList[item].mofId
                    ][0].clearFiles()
                  }
                  this.$set(
                    this.photoList,
                    ['photo_' + this.imoprtCustomData.columnsList[item].mofId],
                    []
                  )
                }
                //17.关联对象类型
                if (
                  this.imoprtCustomData.columnsList[item].fieldType ==
                  this.fieldTypeObject
                ) {
                  this.$set(
                    this.imoprtCustomData.columnsList[item],
                    'fieldValue',
                    ''
                  )
                  this.$set(
                    this.imoprtCustomData.columnsList[item],
                    'dicOptions',
                    []
                  )
                  // 查询主对象下，某列的下拉选项值（主子明细字段）
                  let itemData = this.imoprtCustomData.columnsList[item]
                  this.$set(
                    this.imoprtCustomData.columnsList[item],
                    'dicOptions',
                    []
                  )
                  this.$http
                    .get(
                        '/scmd/Object/baseGetObject?moId=' +
                        itemData.associatedObject +
                        '&objectState=1'
                    )
                    .then(response => {
                      if (response.data.returnCode === 0) {
                        if (response.data.beans.length > 0) {
                          let parentObjectTname =
                            response.data.beans[0].objectTname
                          this.$http
                            .post(
                                '/scmd/dynObject/operObjectInfo',
                              {
                                Head: {
                                  method: this.selectType,
                                  version: this.version
                                },
                                Data: [
                                  {
                                    moId: itemData.associatedObject,
                                    OBJECT_NAME: parentObjectTname,
                                    whereOf: ' is_delete = 0 ',
                                    columns: '*',
                                    page: {
                                      pageNumber: '1',
                                      pageSize: '0'
                                    },
                                    orderBy: 'create_date desc'
                                  }
                                ]
                              }
                            )
                            .then(res => {
                              let resultMainData = res.data.beans
                              for (let i = 0; i < resultMainData.length; i++) {
                                this.imoprtCustomData.columnsList[
                                  item
                                ].dicOptions.push({
                                  label: resultMainData[i].mt_id,
                                  value:
                                    resultMainData[i][
                                      this.imoprtCustomData.columnsList[item]
                                        .referenceCname
                                    ],
                                  show: true,
                                  currentObjectBean: resultMainData[i]
                                })
                              }
                            })
                        }
                      }
                    })
                }
                //19.主子明细类型
                if (
                  this.imoprtCustomData.columnsList[item].fieldType ==
                  this.fieldTypeMainChild
                ) {
                  this.$set(
                    this.imoprtCustomData.columnsList[item],
                    'fieldValue',
                    ''
                  )
                  this.$set(
                    this.imoprtCustomData.columnsList[item],
                    'dicOptions',
                    []
                  )
                  // 查询主对象下，某列的下拉选项值（主子明细字段）
                  let itemData = this.imoprtCustomData.columnsList[item]
                  this.$http
                    .get(
                        '/scmd/Object/baseGetObject?moId=' +
                        itemData.associatedObject +
                        '&objectState=1'
                    )
                    .then(response => {
                      if (response.data.returnCode === 0) {
                        if (response.data.beans.length > 0) {
                          let parentObjectTname =
                            response.data.beans[0].objectTname
                          this.$http
                            .post(
                                '/scmd/dynObject/operObjectInfo',
                              {
                                Head: {
                                  method: this.selectType,
                                  version: this.version
                                },
                                Data: [
                                  {
                                    moId: itemData.associatedObject,
                                    OBJECT_NAME: parentObjectTname,
                                    whereOf: ' is_delete = 0 ',
                                    columns:
                                      'mt_id,' + itemData.referenceCname,//itemDataObject.referenceCname,
                                    page: {
                                      pageNumber: '1',
                                      pageSize: '1000'
                                    },
                                    orderBy: 'create_date desc'
                                  }
                                ]
                              }
                            )
                            .then(res => {
                              let resultMainData = res.data.beans
                              for (let i = 0; i < resultMainData.length; i++) {
                                this.imoprtCustomData.columnsList[
                                  item
                                ].dicOptions.push({
                                  label: resultMainData[i].mt_id,
                                  value:
                                    resultMainData[i][
                                      this.imoprtCustomData.columnsList[item]
                                        .referenceCname
                                    ],
                                  show: true,
                                  currentObjectBean: resultMainData[i]
                                })
                              }
                            })
                        }
                      }
                    })
                }
              }
              // this.queryCustomDatas();
            })
            // console.log(this.imoprtCustomData.columnsList);
          }
        })
    },
    // 选择关联对象命中事件
    getObjectSelectData(item, opt) {
      let currentData = Object.keys(opt.currentObjectBean)
      for (let i = 0; i < currentData.length; i++) {
        for (let j = 0; j < this.dymaticKeyList.length; j++) {
          if (this.dymaticKeyList[j].fieldType == mConst.fieldTypeObjectParam) {
            if (
              currentData[i] == this.dymaticKeyList[j].referenceCname &&
              item.businessLinkages == this.dymaticKeyList[j].businessLinkages
            ) {
              this.dymaticKeyList[j].fieldValue =
                opt.currentObjectBean[currentData[i]]
            }
          }
        }
      }
    },
    //上传前对图片张数做验证
    handleBeforeUpload(item, res, file, fileList) {
      if (
        typeof this.photoList['isPushList_' + item.mofId] != 'undefined' &&
        this.photoList['pushList_' + item.mofId].length > 0
      ) {
        //编辑
        const check =
          this.$refs['upload_' + item.mofId][0].fileList.length <
          item.picUploadNum - this.photoList['photo_' + item.mofId].length
        if (!check) {
          this.$Notice.warning({
            title: '最多导入照片' + item.picUploadNum + '张'
          })
        }
        return check
      } else {
        //新增
        const check =
          this.$refs['upload_' + item.mofId][0].fileList.length <
          item.picUploadNum
        if (!check) {
          this.$Notice.warning({
            title: '最多导入照片' + item.picUploadNum + '张'
          })
        }
        return check
      }
    },
    // 点击上传图片成功
    handlePhotoSuccess(item, res, file, fileList) {
      if (res) {
        //上传成功
        item.fieldValue = item.fieldValue + res.bean.attachmentId + ',' //该字段赋值
        if (typeof this.photoList['isPushList_' + item.mofId] == 'undefined') {
          this.$set(this.photoList, 'photoSuccess_' + item.mofId, true) //成功标志
          this.photoList['photo_' + item.mofId] = this.$refs[
            'upload_' + item.mofId
          ][0].fileList
          //this.photoList['photo_'+item.mofId]=fileList;
          //this.$set(this.photoList, 'photo_'+item.mofId, fileList);
        } else {
          if (!this.photoList['isPushList_' + item.mofId]) {
            let bindData = JSON.parse(
              JSON.stringify(this.photoList['pushList_' + item.mofId])
            ) //旧数据
            var photo = []
            if (bindData != null) {
              for (let s = 0; s < bindData.length; s++) {
                photo.push(bindData[s])
              }
            }
            this.photoList['photo_' + item.mofId] = photo.concat(fileList)
          }
        }
      } else {
        this.$Message.error('上传照片失败')
      }
    },
    // 删除照片事件
    handleRemovePhoto(item, photo) {
      var delTip = confirm('确认删除照片')
      if (delTip == true) {
        // console.log('您已点击确认删除');
        const fileList = this.photoList['photo_' + item.mofId]
        this.$refs['upload_' + item.mofId][0].fileList.splice(
          fileList.indexOf(photo),
          1
        )
        this.$http
          .get(
              '/file/filemanage/deleteFileById/' +
              photo.response.bean.attachmentId
          )
          .then(response => {
            if (response.data.returnCode == 0) {
              this.$Message.success('删除照片成功')
              item.fieldValue = item.fieldValue.replace(
                photo.response.bean.attachmentId + ',',
                ''
              )
            } else {
              this.$Message.error(response.data.returnMessage)
            }
          })
          .catch(error => {
            this.$Message.error('删除发生错误')
          })
      }
    },
    // 放大查看图片
    handleView(file) {
      this.imgPreview =
        '/file/filemanage/downloadFileById/' +
        file.response.bean.attachmentId
      this.visible = true
    },
    // 校验规则
    rulesParams(item) {
      let arr = []
      if (
        item.itsProperties == this.itsPropertiesMain ||
        item.itsProperties == this.itsPropertiesObject ||
        item.itsProperties == this.itsPropertiesSystem
      ) {
        if (typeof item.minLength == 'undefined' || item.minLength == null) {
          item.minLength = 0
        }
        return [
            {
            required: item.isRequired,
            message: '请输入内容',
            trigger: 'blur'
          }
        ]
        // if (item.fieldType == this.fieldTypeMainChild) {
        //   //文本， 最小长度
        //   return [
        //     {
        //       required: item.isRequired,
        //       message: '请输入内容',
        //       trigger: 'blur'
        //     },
        //     {
        //       validator: dynicMaxAndMinLength,
        //       trigger: 'change',
        //       maxLength: item.maxLength,
        //       minLength: item.minLength
        //     }
        //   ]
        // }
      }
    }
  }
}
</script>
<style scoped>
.import-tip {
  width: 460px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(94, 95, 119, 1);
  line-height: 22px;
}
.import-tip-top {
  margin-top: 8px;
  margin-bottom: 24px;
}
.import-tip-top .ivu-icon {
  margin-right: 4px;
}
.import-tip-down a {
  color: #04cbd8;
  cursor: pointer;
}
.import-tip-gray a {
  color: #cdcdcd;
}
.import-title {
  font-family: 'PingFangSC-Medium';
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: 600;
  color: #33344a;
  margin-bottom: 16px;
}
.import-title-gray {
  color: #cdcdcd;
}
.error-tip {
  height: 18px;
  font-size: 12px;
  font-family: 'PingFangSC-Regular';
  font-weight: 400;
  color: #e14040;
  line-height: 18px;
}
.success-tip {
  width: 484px;
  height: 66px;
  margin-top: 12px;
  padding-top: 12px;
  padding-left: 12px;
  background: #f7fafa;
  color: #5e5f77;
  font-size: 14px;
  font-family: 'PingFangSC-Regular';
  font-weight: 400;
  line-height: 22px;
}
.success-tip .ivu-icon {
  margin-right: 4px;
}
.import-model .import-footer {
  width: 600px;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
.import-model >>> .ivu-form-item-content {
  margin-left: 0 !important;
}
.import-model >>> .ivu-drawer-header {
  padding-left: 36px;
}
.import-model >>> .ivu-drawer-body {
  padding-left: 36px;
  padding-bottom: 54px;
}
.import-model >>> .ivu-form-item {
  margin-bottom: 0px !important;
}
.import-model >>> .import-busType .ivu-form-item-content .ivu-select {
  width: 484px;
}
.import-model >>> .import-busType1 .ivu-form-item-content .ivu-select {
  width: 384px;
  margin-bottom: 16px;
}
.export-model >>> .ivu-form-item-content {
  margin-left: 20px !important;
}
.export-model >>> .ivu-drawer-header {
  padding-left: 36px;
}
.checkBoxFlex {
  display: flex;
  flex-direction: column;
}
.fileinfo {
  display: inline-block;
  max-width: 100%;
  margin-top: 12px;
  position: relative;
  padding-right: 30px;
}
.filename {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
}
.btn-delete {
  line-height: 1;
  position: absolute;
  top: -2px;
  right: 0;
  font-size: 20px;
}
.custom-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.custom-upload-list img {
  width: 100%;
  height: 100%;
}
.custom-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.custom-upload-list:hover .custom-upload-list-cover {
  display: block;
}
.custom-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.import-busType1 >>> .ivu-form-item-error-tip{
  top: 32px;
  left:80px;
}
</style>